/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc PC端实名认证,成功后返回uuid
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  identifyDTO: member.IdentifyDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/pc/setting/identify`,
    data: identifyDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
